export const executeNetworkAsync = async (callback: any) => {
  try {
    const response = await callback();
    return [response.data, null];
  } catch (error: any) {
    console.error("executeNetworkAsync", error);
    const errorData = error.response?.data;
    const status = error.response?.status;

    // For lockout (423) responses, preserve all lockout information
    if (status === 423) {
      return [
        null,
        {
          error: true,
          locked: true,
          message: errorData?.message || "Account temporarily locked",
          permanent: errorData?.permanent || false,
          remainingSeconds: errorData?.remainingSeconds || 0,
        },
      ];
    }

    // For other errors, return generic error info
    return [
      null,
      { error: true, message: errorData?.message || "An error occurred" },
    ];
  }
};
